import { AbstractLoaderDialogProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractLoaderDialogProperties";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { LoaderFontStyle } from "@lib/titan2/dist/game/view/style/CommonFontStyle";
import { LoaderStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import { deepEquals } from "../../../utils/deepEquals";
import { GameLang } from "../lang/GameLang";
import { GameLoaderFontStyle } from "../style/GameFontStyle";
/**
 * Game-specific properties for the pre-game loader dialog.
 */
export class GameLoaderDialogProperties extends AbstractLoaderDialogProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.progressFieldProperties.visible = false;
        this.backgroundProperties.anchor.set(0.5);
        this.playButtonProperties = new ButtonProperties(LoaderStyle.CONTINUE_BUTTON, LoaderStyle.MODULE);
        this.playButtonProperties.textFieldProperties = new TextFieldProperties(LoaderFontStyle.PLAY_BUTTON, null, GameLang.LOADER_PLAY_BUTTON);
        this.centerTextProperties = new TextFieldProperties(GameLoaderFontStyle.INFO_FIELD_SLINGO, null, GameLang.LOADER_GUIDE_BODY_1, null, ControlConstants.BOTTOM);
        this.centerTextProperties.setMultiline(true);
        this.centerTextProperties.visible = false;
        this.rightTextProperties = new TextFieldProperties(LoaderFontStyle.GUIDE_BODY, null, GameLang.LOADER_GUIDE_BODY_0, null, ControlConstants.CENTER);
        this.rightTextProperties.setMultiline(true);
        this.leftTextProperties = new TextFieldProperties(LoaderFontStyle.GUIDE_BODY, null, GameLang.LOADER_GUIDE_BODY_2, null, ControlConstants.CENTER);
        this.leftTextProperties.setMultiline(true);
        this.infoFieldFooterProperties = new TextFieldProperties(GameLoaderFontStyle.FOOTER, null, GameLang.LOADER_GUIDE_BODY_3_0);
        this.copyrightProperties = new TextFieldProperties(LoaderFontStyle.COPYRIGHT, null, GameLang.COPYRIGHT);
        this.versionFieldProperties.setHorizontalAlign(ControlConstants.RIGHT);
    }
    equals(other) {
        return deepEquals(other, this);
    }
}
//# sourceMappingURL=GameLoaderDialogProperties.js.map